// extracted by mini-css-extract-plugin
export default {"aboutTitle":"styles_aboutTitle__G-K9+","payInFont":"styles_payInFont__jvBWt","cancelBtn":"styles_cancelBtn__HOPSK","certName":"styles_certName__rTyP3"};